import React, { Suspense, useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Layout from "./components/layout";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { publicRoutes, privateRoutes } from "./route";
import Cookies from "js-cookie";
import { BillProvider } from "./pages/Bill/BillContext";
import { RegionProvider } from "./Context/RegionsContext";
import { ProfileProvider } from "./Context/ProfileContext";
import PrivateRoute from "./route/privateroute";
import Publicroute from "./route/publicroute"; // Import Publicroute
import Spinner from "react-bootstrap/Spinner";
import { CheckToken } from "./components/Service/UserService";
import { zzder } from "./Context/Servercontext";
import { ServerProvider } from "./Context/Servercontext";
// const LoadingSpinner = () => (
//   <div className="d-flex justify-content-center align-items-center vh-100">
//     <Spinner animation="border" role="status">
//       <span className="visually-hidden">Loading...</span>
//     </Spinner>
//   </div>
// );

const MainApp = () => {
  const [isTokenValid, setIsTokenValid] = useState(false);
  const [loading, setLoading] = useState(true);
  const token = Cookies.get("Token");

  useEffect(() => {
    const verifyToken = async () => {
      if (token) {
        try {
          const response = await CheckToken(token);
          if (response.status === "success") {
            setIsTokenValid(true);
          } else {
            Cookies.remove("Token");
          }
        } catch (error) {
          Cookies.remove("Token");
        }
      }
      setLoading(false);
    };
    verifyToken();
  }, [token]);

  // if (loading) {
  //   return <LoadingSpinner />;
  // }

  return (
    <BillProvider>
      <RegionProvider>
        <ServerProvider>
          <Router>
            <div className="App">
              {/* <Suspense fallback={<LoadingSpinner />}> */}
              <Routes>
                {/* Sử dụng Publicroute cho các trang công khai */}
                {publicRoutes.map((route, index) => (
                  <Route
                    key={index}
                    path={route.path}
                    element={<Publicroute component={route.component} />}
                  />
                ))}

                {/* Sử dụng PrivateRoute cho các trang riêng tư */}
                {privateRoutes.map((route, index) => (
                  <Route
                    key={index}
                    path={route.path}
                    element={
                      <Layout showFooter={route.showFooter ?? true}>
                        <PrivateRoute component={route.component} />
                      </Layout>
                    }
                  />
                ))}

                {/* Redirect mặc định */}
                <Route
                  path="/"
                  element={
                    isTokenValid ? <Navigate to="/dashboard" /> : <Navigate to="/" />
                  }
                />
              </Routes>
              {/* </Suspense> */}
            </div>
          </Router>
        </ServerProvider>
      </RegionProvider>
    </BillProvider>
  );
};

function App() {
  return (
    <ProfileProvider>
      <MainApp />
    </ProfileProvider>
  );
}

export default App;
